
































import { Component, Vue } from 'vue-property-decorator'
import router from '../router'

@Component
export default class Login extends Vue {
  form = {
    remember: false,
    email: '',
    password: ''
  }

  loading: boolean = false

  rules = {
    email: [
      { required: true, message: 'Email must not be empty', trigger: 'blur' },
    ],
    password: [
      { required: true, message: 'Password must not be empty', trigger: 'blur' },
    ],
  }

  mounted() {
    if (localStorage.username) {
      this.form.email = localStorage.username
      this.form.remember = true
    }
  }

  async login() {
    if (!this.form.email || !this.form.password) {
      return this.$message.error('Email and password must not be empty');
    }
    this.loading = true
    try {
      await this.$store.dispatch('login', this.form);
      this.loading = false
      if (this.form.remember) {
        localStorage.setItem('username', this.form.email)
      }
      else {
        localStorage.removeItem('username')
      }
      router.push({name: 'Record'})
    }
    catch(e) {
      this.$message.error('Email and password combination incorrect, please check!');
      this.loading = false
    }
  }
}
